export default {
  Get: {
    PAGEACTIVE: "getPageActive",
    HORIZONTALPAGE: "getHorizontalPage",
    USERSESSION: "getUserSession",
    IS_OPEN_MODAL: "getIsOpenModal",
    MAPOPTIONS: "getMapOptions",
    MAPREGIONS: "getMapRegion",
    PLACE_SUGGESTION: "getPlaceSuggestion",
    PREV_QUERY: "getPreviousQuery",
    PREV_QUERY_PEOPLE: "getPreviousQueryPeople",
    LIST_OF_PEOPLE: "getListOfPeople",
    LIST_OF_SEARCH_PROPERTY: "getListOfSearchProperty",
    GRID_CONFIGS: "getGridConfigs",
    GET_LOADING_PAGE: "getLoadingPage",
    GET_STREAMING_PAGE: "getStreaming",
    PERSON_MERGE_DATA_TEMP: "personMergeDataTemp",
        WEBAPP_LAYOUT: 'webappLayout'
  },
  Set: {
    PAGEACTIVE: "setPageActive",
    ASSIGNVALUE: "setValue",
    ASSIGNVALUE_PROJECT_GENERAL: "setValueProjectGeneral",
    ASSIGNVALUE_PROJECT_DESCRIPTIONS: "setValueProjectDescriptions",
    ASSIGNVALUE_PROJECT_BUILDING: "setValueProjectBuilding",
    ASSIGNVALUE_PROJECT_BUILDING_NEW: "setValueProjectBuildingNew",
    ASSIGNVALUE_PROJECT_BUILDING_REMOVE: "setValueProjectBuildingRemove",
    ASSIGNVALUE_TO_ORIGINOBJECT: "setValueForOriginalObject",
    PAGEREADY: "setPageReady",
    HORIZONTALPAGE: "setHorizontalPage",
    MAPOPTIONS: "setMapOptions",
    MAPREGIONS: "setMapRegion",
    TYPE_OF_PROPERTY_ID: "setTypeOfPropertyId",
    USERSESSION: "setUserSession",
    LOADING: "setLoading",
    STREAMING: "setStreamingPage",
    ERROR_MSG: "setErrorMsg",
    PAGINATION: "setPagination",
    IS_OPEN_MODAL: "setIsOpenModal",
    PROPERTY_OF_MODEL: "setPropertyOfModel",
    PLACE_SUGGESTION: "setPlaceSuggestion",
    PREV_QUERY: "setPreviousQuery",
    PREV_QUERY_PEOPLE: "setPreviousQueryPeople",
    MODAL_VISIBLE: "setModalVisible",
    LIST_OF_PEOPLE: "setListOfPeople",
    GRID_CONFIGS_PROPERTY: "setGridConfigsProperty",
    GRID_CONFIGS_PERSON: "setGridConfigsPerson",
    GRID_CONFIGS_DEMAN: "setGridConfigsDeman",
    GRID_CONFIGS_TASK: "setGridConfigsTask",
    SET_LOADING_PAGE: "setLoadingPage",
    SET_STREAMING_PAGE: "setStreamingPage",
    GRID_CONFIGS: "setGridConfigs",
    SEND_MESSAGE_MODAL_VISIBLE: "setSendMessageModalVisible",
    SEND_SMS_MODAL_VISIBLE: "setSendSMSModalVisible",
    LARGE_MAILING_MODAL_VISIBLE:"setLargeMailingModalVisible",
    PROPERTY_OF_PERSON_ORIGINAL_MODEL: "setPropertyOfOriginalModel",
    PERSON_MERGE_DATA_TEMP: "personMergeDataTemp",
    WEBAPP_LAYOUT: 'webappLayout',
    ASSIGNVALUE_TO_ORIGINBUILDING_UNIT: "setUnitsForOriginalBuilding",
    ASSIGNVALUE_PROJECT_BUILDING_UNITS: "setValueProjectBuildingUnits",
  }
};

export const COMMON_LOOKUP_TYPE = {
  SET_COMMON_VISITED_VIEWS: "setCommonVisitedViews",
  GET_COMMON_VISITED_VIEWS: "getCommonVisitedViews",
  UPDATE_COMMON_VISITED_VIEWS: "updateCommonVisitedViews",
  DELETE_COMMON_VISITED_VIEWS: "deleteCommonVisitedViews",
  GET_CONSULTED_NEXT_PERSON: "getConsultedNextPerson",
  GET_GRID_CONFIG_USED_USERS: "getGridConfigsUsedUsers",
  GLOBAL_SEARCH: "globalSearch",
};

export const COMMON_ROUTER_MANAGER = {
  GET_LIST_ROUTER: "getListRouter",
  GET_LASTEST_ROUTE_LEVEL: "getLastestRouteLevel",
  UPDATE_LIST_ROUTER: "updateListRouter",
  REMOVE_LIST_ROUTER: "removeListRouter",
  CLEAR_LIST_ROUTER: "clearListRouter"
};

export const COMMON_MESSAGE_NOTIFICATION = {
  GET_FILTER: "getFilterMessageNotification",
  SET_FILTER: "setFilterMessageNotification",
  GET_MARK_READ: "getMarkReadMessageNotificationIds",
  SET_MARK_READ: "setMarkReadMessageNotificationIds",  
  REMOVE_MARK_READ: "removeMarkReadMessageNotificationIds",
  CLEAR_ALL_MARK_READ: "clearAllMarkReadMessageNotificationIds"  
}
export interface QuickViewPropsModel {
	type: string,
	id: number | string
}

export interface OpenAppointmentPropsModel {
	propertyId: number;
	propertyRef: string;
}